export default __webpack_public_path__ + "static/media/grace_period_notification.79a26156.svg";